<script>
  import { useForm, usePage } from '@inertiajs/svelte';
  import { onMount } from 'svelte';
  import { Button } from '$lib/components/ui/button';
  import { Card, CardContent, CardHeader, CardTitle } from '$lib/components/ui/card';
  import { Input } from '$lib/components/ui/input';
  import { Label } from '$lib/components/ui/label';
  import { Link } from '@inertiajs/svelte';

  // 1. 核心修改：从 mobile 换回 email_address
  const form = useForm({
    email_address: '', 
    name: '',
    password: '',
    password_confirmation: '',
    timezone: '',
    locale: ''
  });

  const page = usePage();
  $: flash = $page.props.flash || {};
  // 这里的 errors 会精准映射 Rails model 的校验错误
  $: errors = $page.props.errors || {};

  onMount(() => {
    $form.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    $form.locale   = navigator.language || 'zh-CN';
  });

  function submit() {
    // 发送到 /register 路由
    $form.post('/register', {
      onError: () => window.scrollTo({ top: 0, behavior: 'smooth' })
    });
  }
</script>

<div class="flex items-center justify-center p-4 min-h-[80vh] bg-zinc-50/50">
  <div class="w-full max-w-md space-y-6">
    <Card class="shadow-xl bg-white">
      <CardHeader>
        <CardTitle class="text-2xl text-center font-bold tracking-tight">创建新账户</CardTitle>
        <p class="text-center text-muted-foreground text-sm">开启你的极光建站之旅</p>
      </CardHeader>

      <CardContent class="space-y-4">
        {#if flash.alert}
          <div class="bg-destructive/10 border border-destructive/20 text-destructive p-3 rounded-md text-sm">
            {flash.alert}
          </div>
        {/if}

        <form on:submit|preventDefault={submit} class="space-y-4">
          <div class="space-y-2">
            <Label for="email_address">电子邮箱</Label>
            <Input
              id="email_address"
              type="email" 
              placeholder="name@example.com"
              bind:value={$form.email_address}
              required
              class="{errors.email_address ? 'border-destructive focus-visible:ring-destructive' : ''}"
            />
            {#if errors.email_address}
              <p class="text-xs text-destructive">{errors.email_address}</p>
            {/if}
          </div>

          <div class="space-y-2">
            <Label for="name">姓名/昵称</Label>
            <Input
              id="name"
              type="text"
              placeholder="怎么称呼你？"
              bind:value={$form.name}
              required
              class="{errors.name ? 'border-destructive focus-visible:ring-destructive' : ''}"
            />
            {#if errors.name}
              <p class="text-xs text-destructive">{errors.name}</p>
            {/if}
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div class="space-y-2">
              <Label for="password">密码</Label>
              <Input
                id="password"
                type="password"
                placeholder="至少8位"
                bind:value={$form.password}
                required
                class="{errors.password ? 'border-destructive focus-visible:ring-destructive' : ''}"
              />
            </div>
            <div class="space-y-2">
              <Label for="password_confirmation">确认密码</Label>
              <Input
                id="password_confirmation"
                type="password"
                placeholder="再次输入"
                bind:value={$form.password_confirmation}
                required
              />
            </div>
            {#if errors.password}
              <p class="col-span-2 text-xs text-destructive">{errors.password}</p>
            {/if}
            {#if errors.password_confirmation}
              <p class="col-span-2 text-xs text-destructive">{errors.password_confirmation}</p>
            {/if}
          </div>

          <Button type="submit" class="w-full" disabled={$form.processing}>
            {$form.processing ? '正在创建账户...' : '立即注册'}
          </Button>
        </form>

        <div class="text-center text-sm pt-2">
          <span class="text-muted-foreground">已有账户？</span>
          <Link href="/login" class="text-primary hover:underline font-semibold ml-1">
            前往登录
          </Link>
        </div>
      </CardContent>
    </Card>
  </div>
</div>